import { createReducer } from '@reduxjs/toolkit'

import { AuthActionTypes } from '@store/auth'
import {
  fetchPostPurchaseBrandConnectAnalytics,
  fetchPostPurchaseBrandConnectAnalyticsError,
  fetchPostPurchaseBrandConnectAnalyticsSuccess,
} from './actions'
import { IPostPurchaseAnalyticsState } from './types'

const initialState: IPostPurchaseAnalyticsState = {
  brandConnectAnalyticsBySubmissionId: {},
  isFetching: false,
  errors: undefined,
}

export const postPurchaseAnalyticsReducer = createReducer(initialState, (builder) =>
  builder
    .addCase(fetchPostPurchaseBrandConnectAnalytics, (state) => {
      state.isFetching = true
    })
    .addCase(fetchPostPurchaseBrandConnectAnalyticsSuccess, (state, action) => {
      state.isFetching = false
      state.errors = undefined
      state.brandConnectAnalyticsBySubmissionId = {
        ...state.brandConnectAnalyticsBySubmissionId,
        [action.payload.submissionId]: action.payload.postPurchaseAnalytics,
      }
    })
    .addCase(fetchPostPurchaseBrandConnectAnalyticsError, (state, action) => {
      state.isFetching = false
      state.errors = action.payload
    })
    .addCase(AuthActionTypes.SIGNOUT_SUCCESS, () => initialState),
)
